import { useEffect } from "react";
import type { CoworldNav } from "@softmax/web-features/site/records";
import { publishPillCoworld } from "./use-pill-coworld";

// The shell sits above the route layout, so the mounted coworld publishes its menu context.
export function PillCoworldMenu({ nav }: { nav: CoworldNav }) {
  useEffect(() => {
    publishPillCoworld(nav);
    return () => publishPillCoworld(null);
  }, [nav]);
  return null;
}
